import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Box, MenuItem, Select, SelectChangeEvent, Menu, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React from "react";
import SwitchToggle from "../../components/SwitchToggle";

const linkedUsers = [
  {
    id: 'u1',
    name: 'Alex Johnson',
    relation: 'Partner',
    role: 'partner',
    permissions: {
      goals: true,
      budgets: false,
      calendar: true
    }
  },
  {
    id: 'u2',
    name: 'Emily Johnson',
    relation: 'Child',
    role: 'viewer',
    permissions: {
      goals: false,
      budgets: false,
      calendar: false
    }
  }
];

const CustomerList = () => {
  const navigate = useNavigate();
  const [resetOpen, setResetOpen] = React.useState(false);
  const [editRoleOpen, setEditRoleOpen] = React.useState(false);

  const [Status, setStatus] = React.useState('default');
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  const users = [
    {
      id: 1,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      gender: "Female",
      dob: "1995-08-12",
      count: "4",
      rate: "10%",
      voiceType: "Natural",
      languages: ["English", "Hindi"],
      address: "#123 Main Street, Downtown",
      subscription: "Premium",
      date: "01 March 2025"
    },
    {
      id: 2,
      name: "John Smith",
      email: "john@example.com",
      phone: "+91 9000011111",
      gender: "Male",
      dob: "1990-04-05",
      count: "4",
      rate: "10%",

      voiceType: "AI",
      languages: ["English"],
      address: "#456 Park Ave",
      subscription: "Free",
      date: "01 March 2025"
    }
  ];

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [menuRowId, setMenuRowId] = React.useState<number | null>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>, rowId: number) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(rowId);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Gender / DOB</TableCell>
              <TableCell>No.of Bookings</TableCell>
              <TableCell>Date Registered</TableCell>
              <TableCell>Cancellation Rate</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow hover key={user.id}>
                <TableCell>
                  <a
                    href="/manage-users/detail"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/manage-users/detail", { state: { user } });
                    }}
                    className="user_block click_action"
                  >
                    <figure>
                      <img
                        src="/static/images/user_placeholder.png"
                        alt={`${user.name}'s profile`}
                      />
                    </figure>
                    <p>
                      <b>{user.name}</b>
                      <span>{user.email}</span>
                      <span>{user.phone}</span>
                    </p>
                  </a>

                </TableCell>
                <TableCell>{user.gender}<br />{user.dob}</TableCell>
                <TableCell>{user.count}</TableCell>
                <TableCell>{user.date}</TableCell>
                <TableCell>{user.rate}</TableCell>

                <TableCell>
                  <SwitchToggle />
                </TableCell>
                <TableCell>
                  <div className="table_actions v2">
                    <Box>
                      <Tooltip title="Edit User" arrow>
                        <IconButton
                          onClick={() => navigate("/manage-users/edit", { state: { user } })}>
                          <img src="/static/images/edit2_icon.svg" alt="Edit" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    <Box>
                      <Tooltip title="View User Details" arrow>
                        <IconButton
                          onClick={() => navigate("/manage-users/detail", { state: { user } })}>
                          <img src="/static/images/eye_icon.svg" alt="View" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>


    </>
  );
};

export default CustomerList;
